/* Global mute state shared across every VimeoPlayer on Home / Works /
   Case Study.

   Design choice: state is IN-MEMORY only (module-scoped) — NOT sessionStorage.
   Why? On a hard reload the browser resets its autoplay-with-sound permission
   window; if we restored an "unmuted" flag from storage the mute button
   would visually read "unmuted" while the video was still silently muted
   by the browser autoplay policy (unmute-after-load requires a user
   gesture on iOS / Android Chrome). Keeping state in memory means:
     - SPA route changes keep the setting (React app instance survives)
     - A hard reload / new tab resets to muted (matches browser reality)
   The user re-clicks once after a reload to unlock audio again. */
import { useCallback, useEffect, useState } from "react";

const EVT = "ap-audio-mute-change";

// Module-scoped source of truth. Default = muted so autoplay works.
let CURRENT_MUTED = true;

export function getMuted() {
  return CURRENT_MUTED;
}

export function setMuted(v) {
  CURRENT_MUTED = !!v;
  window.dispatchEvent(new CustomEvent(EVT, { detail: { muted: CURRENT_MUTED } }));
}

export function useAudioMute() {
  const [muted, setMutedState] = useState(getMuted);
  useEffect(() => {
    const h = (e) => setMutedState(!!e.detail?.muted);
    window.addEventListener(EVT, h);
    return () => window.removeEventListener(EVT, h);
  }, []);
  const toggle = useCallback(() => setMuted(!getMuted()), []);
  return { muted, toggle };
}
